<template>
  <div class="contributor-overview-container">

    <!-- 图表+表格区域 -->
    <div class="trend-columns">
      <!-- 左侧：新增贡献趋势 + 新增贡献表格 -->
      <div class="trend-column">
        <!-- 新增贡献趋势 -->
        <div class="chart-card">
          <div class="chart-header">
            <!-- 筛选栏 -->
            <div class="filter-bar">
              <div class="filter-item">
                <span class="filter-label">项目维度</span>
                <a-select v-model:value="projectDimensionNew" style="width: 100px" @change="handleDimensionChangeNew">
                  <a-select-option value="all">全部</a-select-option>
                  <a-select-option value="openharmony">主干</a-select-option>
                  <a-select-option value="openharmony-sig">孵化仓</a-select-option>
                  <a-select-option value="openharmony-tpc">TPC</a-select-option>
                </a-select>
              </div>
            </div>
            <h3 class="chart-title">新增贡献趋势</h3>
            <div class="chart-tabs">
              <a-button :type="chartTypeNew === 'contributor' ? 'primary' : 'default'"
                @click="handleChartTypeChange('new', 'contributor')">
                贡献者
              </a-button>
              <a-button :type="chartTypeNew === 'code' ? 'primary' : 'default'"
                @click="handleChartTypeChange('new', 'code')">
                代码量
              </a-button>
            </div>
          </div>
          <a-spin :spinning="loadingNew" tip="加载中...">
            <div ref="newContributorChart" class="chart-container"></div>
          </a-spin>
          <div class="chart-legend">
            <span class="legend-item"><span class="legend-dot non-huawei"></span>非华为</span>
            <span class="legend-item"><span class="legend-dot huawei"></span>华为</span>
            <span class="legend-item"><span class="legend-dot total"></span>总数</span>
          </div>
        </div>

        <!-- 新增贡献表格 -->
        <div class="table-card">
          <h3 class="table-title">新增贡献</h3>
          <a-spin :spinning="loadingNew" tip="加载中...">
            <a-table :data-source="newContributorTableData" :columns="newContributorColumns" :pagination="false"
              bordered />
          </a-spin>
        </div>
      </div>

      <!-- 右侧：累计贡献趋势 + 累计贡献表格 -->
      <div class="trend-column">
        <!-- 累计贡献趋势 -->
        <div class="chart-card">
          <div class="chart-header">

            <!-- 筛选栏 -->
            <div class="filter-bar">
              <div class="filter-item">
                <span class="filter-label">项目维度</span>
                <a-select v-model:value="projectDimensionTotal" style="width: 100px"
                  @change="handleDimensionChangeTotal">
                  <a-select-option value="all">全部</a-select-option>
                  <a-select-option value="openharmony">主干</a-select-option>
                  <a-select-option value="openharmony-sig">孵化仓</a-select-option>
                  <a-select-option value="openharmony-tpc">TPC</a-select-option>
                </a-select>
              </div>
            </div>
            <h3 class="chart-title">累计贡献趋势</h3>
            <div class="chart-tabs">
              <a-button :type="chartTypeTotal === 'contributor' ? 'primary' : 'default'"
                @click="handleChartTypeChange('total', 'contributor')">
                贡献者
              </a-button>
              <a-button :type="chartTypeTotal === 'code' ? 'primary' : 'default'"
                @click="handleChartTypeChange('total', 'code')">
                代码量
              </a-button>
            </div>
          </div>
          <a-spin :spinning="loadingTotal" tip="加载中...">
            <div ref="totalContributorChart" class="chart-container"></div>
          </a-spin>
          <div class="chart-legend">
            <span class="legend-item"><span class="legend-dot non-huawei"></span>非华为</span>
            <span class="legend-item"><span class="legend-dot huawei"></span>华为</span>
            <span class="legend-item"><span class="legend-dot total"></span>总数</span>
          </div>
        </div>

        <!-- 累计贡献表格 -->
        <div class="table-card">
          <h3 class="table-title">累计贡献</h3>
          <a-spin :spinning="loadingTotal" tip="加载中...">
            <a-table :data-source="totalContributorTableData" :columns="totalContributorColumns" :pagination="false"
              bordered />
          </a-spin>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, nextTick } from 'vue';
import axios from 'axios';
import * as echarts from 'echarts';

const projectDimensionNew = ref('all');
const projectDimensionTotal = ref('all');
const chartTypeNew = ref('contributor');
const chartTypeTotal = ref('contributor');
const loadingNew = ref(false);
const loadingTotal = ref(false);

let newContributorChartInstance = null;
let totalContributorChartInstance = null;
const newContributorChart = ref(null);
const totalContributorChart = ref(null);

const newYears = ref(['2020年', '2021年', '2022年', '2023年', '2024年', '2025年', '2026年']);
const totalYears = ref(['2020年', '2021年', '2022年', '2023年', '2024年', '2025年', '2026年']);
const newTableYears = ref(['2020', '2021', '2022', '2023', '2024', '2025', '2026']);
const totalTableYears = ref(['2020', '2021', '2022', '2023', '2024', '2025', '2026']);

const emptyChart = () => ({
  total: [],
  huawei: [],
  nonHuawei: []
});

const transformApiData = (apiData = [], type = 'contributor') => {
  const huawei = [];
  const nonHuawei = [];
  const total = [];
  const yearsArr = [];

  if (!Array.isArray(apiData)) {
    return { huawei, nonHuawei, total, yearsArr };
  }

  apiData.forEach((item) => {
    const year = Number(item.year);
    yearsArr.push(`${year}年`);
    if (type === 'code') {
      huawei.push(Number(item.huaweiChangeNum || 0));
      nonHuawei.push(Number(item.nonHuaweiChangeNum || 0));
      total.push(Number(item.totalChangeNum || 0));
    } else {
      huawei.push(Number(item.huaweiNum || 0));
      nonHuawei.push(Number(item.nonHuaweiNum || 0));
      total.push(Number(item.totalNum || 0));
    }
  });

  return { huawei, nonHuawei, total, yearsArr };
};



const chartToTable = (chart, tableYearsArr = []) => {
  const buildRow = (key, category, values) => ({
    key,
    category,
    ...tableYearsArr.reduce((acc, year, index) => {
      acc[year] = values[index] ?? 0;
      return acc;
    }, {})
  });

  return [
    buildRow('total', '总数', chart.total),
    buildRow('huawei', '华为', chart.huawei),
    buildRow('nonHuawei', '非华为', chart.nonHuawei)
  ];
};

const newApiData = ref([]);
const totalApiData = ref([]);

const newContributorChartData = ref(emptyChart());
const totalContributorChartData = ref(emptyChart());
const newContributorTableData = ref([]);
const totalContributorTableData = ref([]);

const applyNewDataByChartType = () => {
  const chart = transformApiData(newApiData.value, chartTypeNew.value);
  newContributorChartData.value = {
    huawei: chart.huawei,
    nonHuawei: chart.nonHuawei,
    total: chart.total
  };
  newYears.value = chart.yearsArr.length ? chart.yearsArr : newYears.value;
  newTableYears.value = newYears.value.map((y) => y.replace('年', ''));
  newContributorTableData.value = chartToTable(newContributorChartData.value, newTableYears.value);
  renderNewChart();
};

const applyTotalDataByChartType = () => {
  const chart = transformApiData(totalApiData.value, chartTypeTotal.value);
  totalContributorChartData.value = {
    huawei: chart.huawei,
    nonHuawei: chart.nonHuawei,
    total: chart.total
  };
  totalYears.value = chart.yearsArr.length ? chart.yearsArr : totalYears.value;
  totalTableYears.value = totalYears.value.map((y) => y.replace('年', ''));
  totalContributorTableData.value = chartToTable(totalContributorChartData.value, totalTableYears.value);
  renderTotalChart();
};

const fetchData = (type) => {
  if (type === 'new') {
    getIncreasementData(projectDimensionNew.value);
    return;
  }
  getTotalData(projectDimensionTotal.value);
};

const getIncreasementData = async (project) => {
  loadingNew.value = true;
  try {
    try {
      const res = await axios.get('/contributorController/getNewContributionTrend', { params: { project } });
      if (res.data.code === 200) {
        newApiData.value = res.data.data;
      } else {
        newApiData.value = [];
      }
      applyNewDataByChartType();
    } catch {
      newApiData.value = [];
      newContributorChartData.value = emptyChart();
      newContributorTableData.value = [];
    }
  } finally {
    loadingNew.value = false;
  }
};

const getTotalData = async (project) => {
  loadingTotal.value = true;
  try {
    try {
      const res = await axios.get('/contributorController/getTotalContributionTrend', { params: { project } });
      if (res.data.code === 200) {
        totalApiData.value = res.data.data;
      } else {
        totalApiData.value = [];
      }
      applyTotalDataByChartType();
    } catch {
      totalApiData.value = [];
      totalContributorChartData.value = emptyChart();
      totalContributorTableData.value = [];
    }
  } finally {
    loadingTotal.value = false;
  }
};

const newContributorColumns = computed(() => [
  { title: '类别', dataIndex: 'category', key: 'category', width: 80 },
  ...newTableYears.value.map((year) => ({ title: year, dataIndex: year, key: year, width: 80 }))
]);
const totalContributorColumns = computed(() => [
  { title: '类别', dataIndex: 'category', key: 'category', width: 80 },
  ...totalTableYears.value.map((year) => ({ title: year, dataIndex: year, key: year, width: 80 }))
]);

// ---------------- 图表渲染 ----------------
const renderNewChart = () => {
  if (!newContributorChartInstance) return;
  const option = {
    tooltip: { trigger: 'axis' },
    legend: { show: false },
    grid: { left: '3%', right: '4%', bottom: '3%', containLabel: true },
    xAxis: {
      type: 'category',
      data: newYears.value,
      axisLine: { lineStyle: { color: '#e5e7eb' } }
    },
    yAxis: {
      type: 'value',
      axisLine: { lineStyle: { color: '#e5e7eb' } },
      splitLine: { lineStyle: { color: '#e5e7eb' } }
    },
    series: [
      {
        name: '非华为',
        type: 'bar',
        stack: 'total',
        itemStyle: { color: '#9ca3af' },
        data: newContributorChartData.value.nonHuawei
      },
      {
        name: '华为',
        type: 'bar',
        stack: 'total',
        itemStyle: { color: '#3b82f6' },
        data: newContributorChartData.value.huawei
      },
      {
        name: '总数',
        type: 'line',
        smooth: true,
        itemStyle: { color: '#10b981' },
        lineStyle: { width: 2 },
        symbol: 'circle',
        symbolSize: 8,
        data: newContributorChartData.value.total
      }
    ]
  };
  newContributorChartInstance.setOption(option);
};

const renderTotalChart = () => {
  if (!totalContributorChartInstance) return;
  const option = {
    tooltip: { trigger: 'axis' },
    legend: { show: false },
    grid: { left: '3%', right: '4%', bottom: '3%', containLabel: true },
    xAxis: {
      type: 'category',
      data: totalYears.value,
      axisLine: { lineStyle: { color: '#e5e7eb' } }
    },
    yAxis: {
      type: 'value',
      axisLine: { lineStyle: { color: '#e5e7eb' } },
      splitLine: { lineStyle: { color: '#e5e7eb' } }
    },
    series: [
      {
        name: '非华为',
        type: 'bar',
        stack: 'total',
        itemStyle: { color: '#9ca3af' },
        data: totalContributorChartData.value.nonHuawei
      },
      {
        name: '华为',
        type: 'bar',
        stack: 'total',
        itemStyle: { color: '#3b82f6' },
        data: totalContributorChartData.value.huawei
      },
      {
        name: '总数',
        type: 'line',
        smooth: true,
        itemStyle: { color: '#10b981' },
        lineStyle: { width: 2 },
        symbol: 'circle',
        symbolSize: 8,
        data: totalContributorChartData.value.total
      }
    ]
  };
  totalContributorChartInstance.setOption(option);
};

// ---------------- 交互事件 ----------------
// 切换项目维度
const handleDimensionChangeNew = () => {
  fetchData('new');
};
const handleDimensionChangeTotal = () => {
  fetchData('total');
};

// 切换chartType
const handleChartTypeChange = (type, chartType) => {
  if (type === 'new') {
    if (chartTypeNew.value === chartType) return;
    chartTypeNew.value = chartType;
    applyNewDataByChartType();
  } else {
    if (chartTypeTotal.value === chartType) return;
    chartTypeTotal.value = chartType;
    applyTotalDataByChartType();
  }
};

// ---------------- 生命周期 ----------------
onMounted(async () => {
  await nextTick();
  newContributorChartInstance = echarts.init(newContributorChart.value);
  getIncreasementData(projectDimensionNew.value);
  totalContributorChartInstance = echarts.init(totalContributorChart.value);
  getTotalData(projectDimensionTotal.value);
  window.addEventListener('resize', () => {
    newContributorChartInstance?.resize();
    totalContributorChartInstance?.resize();
  });
});
</script>

<style scoped>
.contributor-overview-container {
  padding: 20px;
  background-color: #f9fafb;
  min-height: 100vh;
}

.trend-columns {
  display: flex;
  gap: 16px;
  align-items: flex-start;
}

.trend-column {
  flex: 1 1 0;
  min-width: 0;
}

.trend-column:only-child {
  flex: 1 1 100%;
  max-width: 100%;
}

.filter-bar {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 20px;
}

.filter-item {
  display: flex;
  align-items: center;
  gap: 8px;
}

.filter-label {
  font-size: 14px;
  color: #374151;
}

.chart-card {
  background: #fff;
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 20px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.chart-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}

.chart-title {
  font-size: 16px;
  font-weight: 600;
  color: #111827;
  margin: 0;
}

.chart-tabs {
  display: flex;
  gap: 8px;
}

.chart-container {
  height: 300px;
  width: 100%;
}

.chart-legend {
  display: flex;
  gap: 20px;
  justify-content: center;
  margin-top: 12px;
}

.legend-item {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 14px;
  color: #374151;
}

.legend-dot {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  display: inline-block;
}

.legend-dot.non-huawei {
  background-color: #9ca3af;
}

.legend-dot.huawei {
  background-color: #3b82f6;
}

.legend-dot.total {
  background-color: #10b981;
}

.table-card {
  background: #fff;
  border-radius: 8px;
  padding: 16px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.table-title {
  font-size: 16px;
  font-weight: 600;
  color: #111827;
  margin: 0 0 16px 0;
}
</style>